import { useEffect, useState } from "react";
import { AccountEditor } from "../../editor/AccountEditor";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _AdquisitionContract, _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { InputDate } from "../../theme/Input/InputDate";
import { InputButton } from "../../theme/Input/InputSearcher";
import { ModalGeneric } from "../../../interfaces";
import { Modal } from "../../theme/Component/Modal";
import { ContractList } from "../../contract/etapa-contrato/contrac/ublinvoice/ContractList";
import { EditorContractByIDAccount } from "./EditorContractByIDAccount";
import { InputMoney } from "../../theme/Input/InputMoney";
import { PrintJson } from "../../theme/Component/PrintJson";

interface Props {
    onChange: Function;
    formdata: any;
}

interface responseProps {
    ContractNumber: string;
    ContractDescription: string;
    ContractValue: number;
    IDAccount: number;
    AccountantDate: any;
    Description: string;
    ExternalCode: string;
    ContractSearched: boolean;
    Contract?: any;
    IDAdquisitionContract?: number
}

export const BudgetRPForm = ({ formdata, onChange }: Props) => {
    const { instance, lista, setLista, bean, setBean } = useDataBean(_AdquisitionContract)
    const [modal, setModal] = useState<ModalGeneric>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const [response, setResponse] = useState<Partial<responseProps>>({});

    useEffect(() => {
        console.log(formdata)
        if (formdata.IDAdquisitionContract) {
            setResponse({
                IDAccount: formdata.IDAccount,
                ContractNumber: formdata.InternalCode,
                ContractValue: formdata.ContractValue,
                ContractSearched: true,
                AccountantDate: _single.getCurrenDate(),
                IDAdquisitionContract: formdata.IDAdquisitionContract
            })
        }
    }, [formdata])

    useEffect(() => {
        onChange(response);
    }, [response])

    const [contrac, setContrac] = useState<any>({});

    const selectClose = () => {
        setModal({ ...modal, "view": false })
        setResponse({
            ...response,
            ContractNumber: contrac.InternalCode,
            ContractDescription: contrac.Description,
            ContractValue: contrac.ContractValue,
            ContractSearched: true,
            Contract: contrac
        })
    }

    const [contractService, setContracService] = useState<any>({});

    useEffect(() => {
        setResponse({
            ...response,
            ContractNumber: contractService.InternalCode,
            ContractDescription: contractService.Description,
            ContractValue: contractService.ContractValue,
            ContractSearched: true,
            Contract: contractService
        })
    }, [contractService])

    useEffect(() => {
        if (response.IDAdquisitionContract) {
            getContract()
        }
    }, [response.IDAdquisitionContract])

    const getContract = () => {
        const x = {
            IDAdquisitionContract: response.IDAdquisitionContract,
        }
        instance.getAdquisitionContractRenderReport(1, 1, x, null, null, 0).then(
            (resp) => {
                setContracService(resp.List[0].DataBeanProperties)
            }
        ).catch(err => { console.log(err) })
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <label >Fecha de Registro</label>
                <InputDate name="" setDate={(e) => { setResponse({ ...response, AccountantDate: e }) }} value={response.AccountantDate} />
            </div>
            <div className="col-md-6">
                <AccountEditor disabled={formdata.IDAccount} idAccount={response.IDAccount} label="Beneficiario/Contratista" onChange={(e) => { setResponse({ ...response, IDAccount: e.IDAccount }) }} />
            </div>

            {
                response.IDAccount &&
                < div className="col-md-6">
                    <InputButton
                        _disable={formdata.ContractValue}
                        _value={response.ContractNumber}
                        _label="No Contrato"
                        buttonClick={() => { setModal({ ...modal, "view": true, "name": "Buscar Contrato por Beneficiaro/Contratista" }) }}
                        onChange={(e) => { setResponse({ ...response, ContractNumber: e, ContractSearched: false }) }}
                        ButtonProps={{
                            labelButton: "Buscar y Seleccionar",
                            iconButton: "ri-search-line",
                            _disableButton: formdata.ContractValue
                        }}
                    />
                </div>
            }
            {
                response.ContractNumber &&
                <>
                    <div className="col-md-6">
                        <InputMoney _value={response.ContractValue} onChange={(e) => { setResponse({ ...response, "ContractValue": e }) }} _label="Valor a Comprometer" readonly={response.ContractSearched} />
                    </div>
                    <div className="col-md-12">
                        <label>Objeto Contrato</label>
                        <textarea rows={5} className="form-control" value={response.ContractDescription} onChange={(e) => { setResponse({ ...response, "ContractDescription": e.target.value }) }} disabled={response.ContractSearched} />
                    </div>
                </>
            }

            <div className="col-md-6">
                <label>Consecutivo Externo</label>
                <input type="text" className="form-control" value={response.ExternalCode} onChange={(e) => { setResponse({ ...response, ExternalCode: e.target.value }) }} />
            </div>
            <div className="col-md-12">
                <label>Descripción</label>
                <textarea className="form-control" value={response.Description} onChange={(e) => { setResponse({ ...response, "Description": e.target.value }) }} />
            </div>


            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={() => {
                    if (contrac.IDAdquisitionContract) {
                        selectClose();
                    } else {
                        toast.error("Contrato no Valido");
                    }
                }} >
                    <EditorContractByIDAccount idContract={response.IDAdquisitionContract} idAccount={response.IDAccount} onChange={(e) => { setContrac(e) }} />
                </Modal>
            </div>
        </div >
    )
}